// assets/custom-scroll-endpoint.js
document.addEventListener('DOMContentLoaded', () => {
  const scrollArea = document.querySelector('.product__scroll-area.rte.custom-scroll');
  if (!scrollArea) return;

  const defaultMaxHeight = 700; // Default height in pixels
  const fullHeight = scrollArea.scrollHeight;

  // Apply initial styles (consistent with CSS)
  scrollArea.style.maxHeight = `${defaultMaxHeight}px`;
  scrollArea.style.overflowY = 'auto';

  // Add "Read More" button if content exceeds default height
  if (fullHeight > defaultMaxHeight) {
    let isExpanded = false;
    const existingButton = scrollArea.nextElementSibling?.classList.contains('read-more-btn');

    if (!existingButton) {
      const button = document.createElement('button');
      button.textContent = 'Read More';
      button.className = 'read-more-btn';
      button.style.cssText = `
        margin-top: 10px;
        padding: 8px 16px;
        cursor: pointer;
        background-color: #f5f5f5;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
      `;
      scrollArea.insertAdjacentElement('afterend', button);

      button.addEventListener('click', () => {
        isExpanded = !isExpanded;
        scrollArea.style.maxHeight = isExpanded ? `${fullHeight}px` : `${defaultMaxHeight}px`;
        scrollArea.style.transition = 'max-height 0.3s ease'; // Smooth transition
        button.textContent = isExpanded ? 'Read Less' : 'Read More';
      });
    }
  }
});